'use client';
import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { FiltersTimeline } from 'features/conge/types/timeline';
import { MHDateValue } from 'components/common/Improvements/MinthrDatePicker';
import moment, { Moment } from 'moment';
import MinthrDateRangePicker from 'components/common/MinthrDateRangePicker';
import { useDebounce } from 'hooks/useDebounce';

const DateTimeLine: React.FC<{
  setSelectedDate: Dispatch<SetStateAction<Moment>>;
  setFilters: Dispatch<SetStateAction<FiltersTimeline>>;
}> = ({ setSelectedDate, setFilters }) => {
  const [date, setDate] = useState(moment());
  const debouncedDate = useDebounce(date, 500);

  const handleDateChange = (
    e: Moment | MHDateValue,
    type?: 'increment' | 'decrement',
  ): void => {
    if (e) {
      let newDate = (e as Moment).clone();
      if (!newDate.isValid()) {
        return;
      }
      if (type === 'increment') {
        newDate = newDate.add(1, 'month');
      } else if (type === 'decrement') {
        newDate = newDate.subtract(1, 'month');
      }
      setDate(newDate);
      setSelectedDate(newDate);
    }
  };

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      month: debouncedDate.month(),
      year: debouncedDate.year(),
    }));
  }, [debouncedDate, setFilters]);

  return (
    <div className="minthr-mobile-w-100 minthr-flex minthr-flex-items-center minthr-mobile-mb-4">
      <MinthrDateRangePicker
        startDate={date}
        selectionMode="month"
        singleDatePicker
        customViewClassName="minthr-mobile-w-100"
        customView={(startDate) => (
          <div
            className="minthr-flex minthr-flex-items-center minthr-py-1 minthr-border minthr-border-rounded minthr-monthdatepicker  minthr-mobile-w-100 minthr-cursor-pointer minthr-mobile-w-100 minthr-mobile-p-2 "
            style={{
              width: 'calc(var(--unit-minthr) * 200)',
            }}
          >
            <div className="minthr-flex minthr-flex-items-center minthr-w-100">
              <img
                className="minthr-icon-s minthr-ml-2"
                src="/icons/calendar.svg"
                alt=""
              />
              <div className="custom-view minthr-w-100 minthr-text-align-center minthr-mr-6 ">
                {startDate?.format?.('MMM YYYY')}
              </div>
            </div>
          </div>
        )}
        onChange={(startDate) => {
          handleDateChange(startDate);
        }}
      />
      <div className="minthr-flex  minthr-position-absolute  minthr-position-r-0">
        <button
          className="minthr-bg-transparent minthr-border-none minthr-px-1"
          onClick={() => {
            handleDateChange(date, 'decrement');
          }}
        >
          <img
            className="minthr-icon-gray minthr-icon-hover-origin minthr-icon-xs minthr-icon-reverse"
            src="/icons/arrow2.svg"
            alt="Previous Month"
          />
        </button>
        <button
          className="minthr-bg-transparent minthr-border-none minthr-px-1 minthr-mr-1"
          onClick={() => {
            handleDateChange(date, 'increment');
          }}
        >
          <img
            className="minthr-icon-gray minthr-icon-hover-origin minthr-icon-xs"
            src="/icons/arrow2.svg"
            alt="Next Month"
          />
        </button>
      </div>
    </div>
  );
};

export default DateTimeLine;
